import "../scss/style.scss";

import { accordion } from "./modules/accordion";
import { buttonRoll } from "./modules/button-roll";
import { dropdown } from "./modules/dropdown";
import { headroom } from "./modules/headroom";
import { mainMenuExtraMarkup } from "./modules/main-menu-extra-markup";
import { overlayMenu } from "./modules/overlay-menu";
import { pdfLinks } from "./modules/pdf-links";
import { popup } from "./modules/popup";
import { tabs } from "./modules/tabs";
import { resourceProtection } from "./modules/resource-protection";

mainMenuExtraMarkup();

buttonRoll();

overlayMenu();

dropdown();

pdfLinks();

accordion();

tabs();

popup();

resourceProtection();

headroom();
